module.exports = require("./haw.d.ts");